import { useI18n } from 'vue-i18n';

const days = ['day7', 'day1', 'day2', 'day3', 'day4', 'day5', 'day6'];
const months = [
    'month1',
    'month2',
    'month3',
    'month4',
    'month5',
    'month6',
    'month7',
    'month8',
    'month9',
    'month10',
    'month11',
    'month12',
];

export function formatDate(date: Date | null, i18n: ReturnType<typeof useI18n<string, string>>): string {
    if (!date) {
        return '';
    }

    const year = date.getFullYear();
    const month = i18n.t(`months.${months[date.getMonth()]}`);
    const dayName = i18n.t(`days.${days[date.getDay()]}`);
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

    return `${dayName} ${day} ${month} ${year}`;
}

export function formatDateToDayAndMonth(date: Date | null, i18n: ReturnType<typeof useI18n<string, string>>): string {
    if (!date) {
        return '';
    }

    const month = i18n.t(`months.${months[date.getMonth()]}`);
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

    return `${day} ${month}`;
}

export function formatTime(date: Date | null): string {
    if (!date) {
        return '';
    }

    const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

    return `${hours}:${minutes}`;
}

export function formatPrice(cents: number, currency: string): string {
    const price = cents !== 0 ? cents / 100 : 0; // Convert cents to proper price

    let currencySymbol = '';

    switch (currency) {
        case 'EUR':
            currencySymbol = '€';
            break;
    }

    const formattedPrice = new Intl.NumberFormat('nl', {
        style: 'decimal',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(price);

    return `${currencySymbol} ${formattedPrice}`;
}
